import { campaignService } from "@/api/campaignService";
import type { CampaignResult, CampaignWithId } from "@/resources/campaign";
import type { CampaignResults, CampaignResultsRow } from "@/resources/package";
import { compareCouponsByCode } from "./getCoupons";
import { transformCampaignResult } from "./transformCampaignResult";

export async function getProcessedCampaignResults(
  campaign: CampaignWithId | null,
): Promise<CampaignResults> {
  const res: CampaignResults = {
    campaignId: "",
    campaignCodeName: "",
    coupons: [],
    rows: [],
  };

  try {
    if (!campaign) {
      return res;
    }
    const campaignResults = await campaignService.getCampaignResults(
      campaign.campaignCode,
    );

    if (!campaignResults || campaignResults.length === 0) {
      return res;
    }

    campaignResults.sort((a, b) => compareCouponsByCode(a.coupon, b.coupon));

    res.campaignCodeName = `${campaign.campaignCode} (${campaign.name})`;
    res.campaignId = campaign.id;

    res.coupons = campaignResults.map(
      (result: CampaignResult) => result.coupon,
    );

    res.rows = campaignResults
      .map((result: CampaignResult) =>
        transformCampaignResult(result, campaign),
      )
      .filter((rows): rows is CampaignResultsRow[] => rows !== null)
      .flat();
  } catch (error) {
    console.error("Error in getProcessedCampaignResults:", error);
  }

  return res;
}
